import React, { useEffect, useState } from 'react'
import MoadlPrintRecharge from './modalPrintRecharge'
import ModalHistoryTransfert from './modalHistoryTransfert'
  import {PROVIDERCONFIG} from '../../containers/rechargeContainer/ProviderRecharge'
  // ../rechargeContainer/ProviderRecharge'

interface Props {
  rechargeData: any
  data? : string

}

const HistoryTableRecharge: React.FC<Props> = ({ rechargeData, data='rechargeMobile' }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [status, setStatus] = useState<string>('Complete')
  const [statusCanceled, setStatusCanceled] = useState<string>('canceled')
  const [statusInProgress, setStatusInProgress] = useState<string>('in progress')
  const [sortDesc, setSortDesc] = useState(true)


  function formatDate(originalDate: any) {
    const dateObj = new Date(originalDate)
    const jour = dateObj.getDate()
    const mois = dateObj.getMonth() + 1
    const annee = dateObj.getFullYear()
    const jourFormatte = jour < 10 ? `0${jour}` : jour
    const moisFormatte = mois < 10 ? `0${mois}` : mois
    return `${jourFormatte}/${moisFormatte}/${annee}`
  }

  // const openModal = () => {
  //   setIsModalOpen(true)
  // }
  // const closeModal = () => {
  //   setIndexrecharge(-1)
  //   setIsModalOpen(false)
  // }
  const [clickedRows, setClickedRows] = useState<boolean[]>([])
  const [infoRecharge, setInfoRecharge] = useState<any>([])
const [openModale, setOpenModale]= useState<boolean>(false)
const[operateur, setOperateur]=useState('')
const[codeCountry, setCodeCountry]=useState('')
  const closeModalHistoryTransfert =()=>{
    setOpenModale(false)
  }
  const handleInputClick = (index: number) => {
    const newClickedRows = [...clickedRows]
    newClickedRows[index] = !newClickedRows[index]
    setClickedRows(newClickedRows)
  }
  return (
    
        <table className="table-fixed w-full text-left">
          <thead>
              <tr className='w-full sm:text-center  font-semibold text-[13px] text-[#AEB6FB] 2xl:text-center lg:text-left'>

           
              <th className="border-b pr-4 py-2 sm:border-none sm:hidden">
                <div className="">{data=== 'cartePrepayee'  ? 'Code de recharge' :'Numéro de téléphone'}</div>
              </th>
              <th className="border-b px-4 py-2 sm:border-none">
                <div className="">Montant de la recharge</div>
              </th>
              <th className="border-b px-4 py-2 sm:border-none ">
                <div className="">Montant payé €</div>
              </th>
              <th className="border-b px-4 py-2 sm:border-none sm:hidden">
                <div className="">Date</div>
              </th>
              <th className="border-b px-4 py-2 sm:border-none">
                <div className=" ">Statut</div>
              </th>
              {/* <th className="border-b px-4 py-2 sm:border-none">
                <div className=" sm:hidden">Reçu</div>
              </th> */}
            </tr>
          </thead>
          
              <tbody>
                {rechargeData &&
                [...rechargeData]
                  .sort((a, b) =>
                    sortDesc
                      ? new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
                      : new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
                  )
                  .map((listRecharge: any, index: number) => (

                <React.Fragment key={index} >
                <tr  className={`${data==='Recharge Mobile' && 'cursor-pointer'} hover:bg-[#F1F1FF]`}
                  onClick={() =>{
                    if(data==='Recharge Mobile')
                    setOpenModale(true), 
                    setCodeCountry(PROVIDERCONFIG[listRecharge.DistributorRef].prefix || ''),  
                    setOperateur(PROVIDERCONFIG[listRecharge.DistributorRef].value || '')
                    setInfoRecharge(listRecharge)}}

                >
                  <td className={`border-b pr-4 lg:pl-4 lg:px-2 py-2`} onClick={() => handleInputClick(index)}>
                    {data === 'cartePrepayee' ?
                    <div>{listRecharge.voucher}</div>
                    :
                    <div className="text-[#22242C] text-[12px] sm:text-[11px] lg:text-[13px] font-semibold flex items-center gap-2">
                      <img className='w-[30px] h-auto' src={PROVIDERCONFIG[listRecharge.DistributorRef].icon} alt=''/>
                    
                      {data==='Recharge Mobile' && PROVIDERCONFIG[listRecharge.DistributorRef].prefix} {listRecharge?.AccountNumber}
                    </div>
                    }
                  </td>

                  <td className="border-b px-4 py-2 sm:hidden ">
                    <div className="text-[#22242C] text-[14px] lg:text-[13px] font-semibold text-center">
                    {data === 'cartePrepayee' ?
                    listRecharge.sendValue
                    :
                      listRecharge?.ReceiveValue ? `${listRecharge?.ReceiveValue} ${listRecharge?.ReceiveCurrencyIso}` : '--'

                    //  <span>{listRecharge?.ReceiveValue} {listRecharge?.ReceiveCurrencyIso}</span> 
                    }
                    </div>
                  </td>
                  <td className="border-b px-4 py-2">
                    <div className="text-[#22242C] text-[14px] lg:text-[13px] font-semibold">
                    {data === 'cartePrepayee' ?
                    listRecharge?.payValue
                    :
                      // listRecharge?.SendValue && `${listRecharge?.SendValue} EUR`
                      listRecharge?.SendValue &&  ` ${listRecharge.isGift?  0 : listRecharge?.SendValue} EUR` 
                    }
                    </div>
                  </td>
                  <td className="border-b px-4 py-2 sm:hidden">
                    <div className="text-[#22242C] text-[14px] lg:text-[13px] font-semibold">
                      {formatDate(listRecharge?.createdAt)}
                    </div>
                  </td>

                  <td className="border-b">
                    {status === listRecharge?.status ? (
                      <div className="bg-[#EBFFF3] flex items-center text-[14px] justify-center w-auto p-2 sm:p-[5px] rounded-lg">
                        <span className="text-[#20C374] ml-1">{listRecharge.isGift ? 'Gratuite' :'Terminé'}</span>
                      </div>
                    ) : statusInProgress === listRecharge?.status ? (
                      <div className="bg-[#FFDECC] flex items-center justify-center w-auto p-2 h-[35px] 2md:h-[22px] text-[14px] rounded-lg">
                        <span className="text-[#FF5C00]">En cours</span>
                      </div>
                    ) : statusCanceled === listRecharge?.status ? (
                      <div className="bg-[#FED7D8]  flex items-center justify-center w-auto p-2 h-[35px] 2md:h-[22px] text-[14px] rounded-lg">
                        <span className="text-[#EC1C24]  ">Annulé</span>
                      </div>
                    ) : (
                      <></>
                    )}
                  </td>
                  {/* <td className="border-b px-4 py-2">
                    <div className="flex ml-4 sm:ml-0">
                      <img
                        src={iconPrint}
                        className="w-5 h-5 mr-5 cursor-pointer sm:hidden"
                        onClick={() => {
                          //openModal()
                          setIndexrecharge(index)
                        }}
                      />
                    </div>
                  </td> */}
                </tr>

             
                </React.Fragment>
                ))}
              </tbody>

               {data==='Recharge Mobile' &&
               <ModalHistoryTransfert
                titreModal='historique de Recharge'
                  isOpen={openModale}
                  closeModal={closeModalHistoryTransfert}
                  beneficiaire={`${codeCountry} ${infoRecharge.AccountNumber}`}
                  montantEnvoye={infoRecharge.paymentProvider==="gift" ?0 : infoRecharge?.SendValue}
                  montantRecevoir={infoRecharge.ReceiveValue}
                  currency={infoRecharge.ReceiveCurrencyIso}
                 
                  date={formatDate(infoRecharge?.createdAt)}
                   distributionChannel={'Recharge Mobile'}
                  status={infoRecharge.status}
                 codeRetrait={operateur}
                /> }
            
        </table>
   
  )
}

export default HistoryTableRecharge
